import React, { useState } from 'react';
import { Loader2, KeyRound, ShieldCheck } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { changePassword } from '../../lib/api';
import { useToast } from '../../hooks/use-toast';

const SettingsPanel = () => {
  const { toast } = useToast();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (next.length < 6) { setError('New password must be at least 6 characters.'); return; }
    if (next !== confirm) { setError('New passwords do not match.'); return; }
    setSaving(true);
    try {
      await changePassword(current, next);
      toast({ title: 'Password updated', description: 'Your admin password has been changed.' });
      setCurrent(''); setNext(''); setConfirm('');
    } catch (err) {
      setError(err?.response?.data?.detail || 'Could not change password.');
    } finally { setSaving(false); }
  };

  return (
    <div>
      <h1 className="font-display text-2xl md:text-3xl font-semibold text-[#123020]">Settings</h1>
      <p className="text-[#5a6b60] mt-1 text-[14px]">Manage your admin account.</p>

      <div className="mt-6 max-w-[480px] bg-white rounded-md p-6 shadow-sm ring-1 ring-[#e6e4d7]">
        <div className="flex items-center gap-2 mb-4"><KeyRound className="h-5 w-5 text-[#5f9e2c]" /><h2 className="font-semibold text-[#123020]">Change Password</h2></div>
        <form onSubmit={submit} className="space-y-4">
          <div><Label className="font-medium">Current Password</Label><Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="mt-1.5" /></div>
          <div><Label className="font-medium">New Password</Label><Input type="password" value={next} onChange={(e) => setNext(e.target.value)} className="mt-1.5" /></div>
          <div><Label className="font-medium">Confirm New Password</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5" /></div>
          {error && <p className="text-[13px] text-red-600">{error}</p>}
          <Button type="submit" disabled={saving} className="bg-[#86c93c] hover:bg-[#75b52f] text-[#123020] font-semibold">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <><ShieldCheck className="mr-2 h-4 w-4" /> Update Password</>}</Button>
        </form>
      </div>
    </div>
  );
};

export default SettingsPanel;
